import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { CertificateGrid } from '@vcd-ecm-ui/CertificateGrid';
import CustomerExemptionsProps from './CustomerExemptionsProps.interface';
import '../../customer-info.scss';

const CustomerExemptions = ({
  customer,
  gatewayEndPoint,
  onCertificateApproved,
  onCertificateEdited,
}: CustomerExemptionsProps): JSX.Element => {
  Logging.Debug('Customer Exemptions');

  return (
    <div className="exemptionsContainer">
      <CertificateGrid
        gatewayEndPoint={gatewayEndPoint}
        displayGridOnly
        parentCustomerUUID={customer.parent ? customer.parent.uuid : null}
        customerUUID={customer.uuid}
        onCertificateApproved={onCertificateApproved}
        onCertificateEdited={onCertificateEdited}
      />
    </div>
  );
};

export default CustomerExemptions;
